/**
 * OUTLAST product page enhancements
 * Mobile thumbnail strip synced with the main photo slider (Swiper 8, created by product-page.js).
 */
( function() {
	'use strict';

	var reduceMotion = window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	/* Accordion open/close is handled by the theme itself (btyAccordion in theme.js). Do not add a second handler here. */

	/* ---------------- 2. Mobile thumbnail strip ---------------- */
	function initThumbs( root ) {
		var strips = ( root || document ).querySelectorAll( '[data-ora-thumbs]' );

		strips.forEach( function( strip ) {
			if ( strip.dataset.oraReady ) {
				return;
			}

			var gallery = strip.closest( '.product-media-box' ),
				mainEl  = gallery ? gallery.querySelector( '.product-main-slide' ) : null,
				thumbs  = strip.querySelectorAll( '.ora-thumb' );

			if ( ! mainEl || ! thumbs.length ) {
				return;
			}

			function setActive( index ) {
				thumbs.forEach( function( t, i ) {
					var on = i === index;
					t.classList.toggle( 'is-active', on );
					t.setAttribute( 'aria-selected', on ? 'true' : 'false' );
				} );

				var active = thumbs[ index ];
				if ( active ) {
					// Keep the active thumbnail in view without moving the page vertically.
					var left = active.offsetLeft - ( strip.clientWidth - active.offsetWidth ) / 2;
					strip.scrollTo( { left: Math.max( 0, left ), behavior: reduceMotion ? 'auto' : 'smooth' } );
				}
			}

			function bind( swiper ) {
				strip.dataset.oraReady = '1';

				thumbs.forEach( function( t ) {
					t.addEventListener( 'click', function() {
						var i = parseInt( t.dataset.index, 10 ) || 0;
						var s = mainEl.swiper;
						if ( s && ! s.destroyed ) {
							s.slideTo( i, reduceMotion ? 0 : 400 );
						}
						setActive( i );
					} );
				} );

				swiper.on( 'slideChange', function( s ) {
					setActive( s.activeIndex );
				} );

				setActive( swiper.activeIndex || 0 );
			}

			// product-page.js creates the slider on mobile; wait for it (max ~6s).
			var tries = 0;
			( function waitForSwiper() {
				if ( mainEl.swiper && ! mainEl.swiper.destroyed ) {
					bind( mainEl.swiper );
					return;
				}
				if ( ++tries < 60 ) {
					setTimeout( waitForSwiper, 100 );
				}
			} )();
		} );
	}

	/* ---------------- 3. Gallery image preloading ---------------- */
	// Each slide has a real <img loading="lazy">. Switching it to "eager" starts the download using the
	// browser's own srcset choice, so the preloaded file is exactly the one shown (no double downloads,
	// served from the browser cache / Shopify CDN afterwards).
	function eager( img ) {
		if ( img && img.getAttribute( 'loading' ) !== 'eager' ) {
			img.setAttribute( 'loading', 'eager' );
		}
	}

	function loadAround( slider, index ) {
		var imgs = slider.querySelectorAll( '[data-ora-gallery-img]' );
		for ( var i = index - 1; i <= index + 2; i++ ) {
			eager( imgs[ i ] );
		}
	}

	function preloadRest( slider ) {
		if ( slider.dataset.oraPreloaded ) {
			return;
		}
		slider.dataset.oraPreloaded = '1';

		var queue = Array.prototype.slice.call( slider.querySelectorAll( '[data-ora-gallery-img][loading="lazy"]' ) );

		// Two at a time, so the visible photo never competes with a big batch of downloads.
		function next() {
			var img = queue.shift();
			if ( ! img ) {
				return;
			}
			if ( img.complete && img.naturalWidth ) {
				next();
				return;
			}
			var done = function() {
				img.removeEventListener( 'load', done );
				img.removeEventListener( 'error', done );
				next();
			};
			img.addEventListener( 'load', done );
			img.addEventListener( 'error', done );
			eager( img );
		}
		next();
		next();
	}

	function initPreload( root ) {
		var sliders = ( root || document ).querySelectorAll( '.product-main-slide' );

		sliders.forEach( function( slider ) {
			if ( slider.dataset.oraPreload ) {
				return;
			}
			slider.dataset.oraPreload = '1';

			// Neighbours of the photo you're on, every time the slide changes (swipe, thumbnail, color).
			var tries = 0;
			( function waitForSwiper() {
				var sw = slider.swiper;
				if ( sw && ! sw.destroyed ) {
					loadAround( slider, sw.activeIndex || 0 );
					sw.on( 'slideChange', function( s ) { loadAround( slider, s.activeIndex ); } );
					sw.on( 'touchStart', function( s ) { loadAround( slider, s.activeIndex ); } );
					return;
				}
				if ( ++tries < 60 ) {
					setTimeout( waitForSwiper, 100 );
				}
			} )();

			// Everything else once the page has finished loading and the browser is idle.
			var start = function() {
				var idle = window.requestIdleCallback || function( cb ) { return setTimeout( cb, 300 ); };
				idle( function() { preloadRest( slider ); }, { timeout: 2000 } );
			};
			if ( document.readyState === 'complete' ) {
				start();
			} else {
				window.addEventListener( 'load', start, { once: true } );
			}
		} );
	}

	function init( root ) {
		initPreload( root );
		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
			initThumbs( root );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', function() { init(); } );
	} else {
		init();
	}

	// If the screen goes from desktop to mobile (rotation / resize), set up the strip then.
	window.addEventListener( 'resize', function() {
		clearTimeout( window.__oraResize );
		window.__oraResize = setTimeout( function() { init(); }, 250 );
	} );

	// Theme editor: re-init when the section reloads.
	document.addEventListener( 'shopify:section:load', function( e ) { init( e.target ); } );
} )();
